import { Maybe } from '../types';

const template = (s: string, d: { [x: string]: Maybe<string> }): string => {
  for (const p in d) {
    if (Object.prototype.hasOwnProperty.call(d, p)) {
      s = s.replace(new RegExp('{' + p + '}', 'g'), d[p] || '');
    }
  }
  return s;
};

export default template;
